export const COMMENT_PADDING = 20;
export const COMMENT_AVATAR_SIZE = 24;
export const COMMENT_AVATAR_RIGHT_MARGIN = 8;
export const COMMENT_AUTHOR_HEADER_LEFT = COMMENT_PADDING + COMMENT_AVATAR_SIZE + COMMENT_AVATAR_RIGHT_MARGIN;
